enum UserTitle {
  Author = 'Author',
  CoAuthor = 'CoAuthor',
  PeerReviewer = 'PeerReviewer',
  Reviewer = 'Reviewer',
  Publisher = 'Publisher',
  Techwriter = 'Techwriter',
  BarRaiser = 'BarRaiser',
  Admin = 'Admin',
}

export default UserTitle;
